<template>
  <ul class="locations">
    <li class="location__item">
      <span class="location__item__label">{{ $t(`${namespace}.origin`) }}</span>
      <div v-if="ride && ride.from && ride.from.street">
        <p class="location__item__address text--ellipsis" :title="ride.from.street">
          {{ ride.from.street }}
        </p>
        <p class="location__item__complement mb-0">{{ ride.from.street | getStateAndCountry }}</p>
      </div>

      <div v-else>
        <p class="location__item__address text--ellipsis">-</p>
        <p class="location__item__complement mb-0">-</p>
      </div>
    </li>

    <li class="location__item">
      <span class="location__item__label">
        {{ $t(`${namespace}.destiny`) }}
        <!-- <v-btn
          color="accent"
          depressed
          round
          @click="handleEditLocation('destiny')"
        >
          Editar
        </v-btn> -->
      </span>
      <div v-if="ride && ride.to && ride.to.street">
        <p class="location__item__address text--ellipsis" :title="ride.to.street">
          {{ ride.to.street }}
        </p>
        <p class="location__item__complement mb-0">{{ ride.to.street | getStateAndCountry }}</p>
      </div>

      <div v-else>
        <p class="location__item__address text--ellipsis">-</p>
        <p class="location__item__complement mb-0">-</p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Locations',
  props: {
    ride: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.rideList.details.locations'
    }
  },
  methods: {
    handleEditLocation (location) {
      console.log('TO DO', location)
    }
  }
}
</script>

<style lang="scss" scoped>
.locations {
  list-style-type: none;
  padding: 0;
  position: relative;

  &:before {
    background-color: $accent;
    bottom: 40px;
    content: '';
    left: 6px;
    position: absolute;
    top: 6px;
    width: 1px;
    z-index: -1;
  }
}

.location__item {
  margin-bottom: 8px;
  padding-left: 24px;
  position: relative;

  &:before,
  &:after {
    border-radius: 50%;
    content: '';
    position: absolute;
  }

  &:before {
    background-color: $accent;
    height: 14px;
    left: 0;
    top: 4px;
    width: 14px;
    z-index: 1;
  }

  &:after {
    background-color: $accent;
    border: 2px solid #fff;
    content: '';
    height: 12px;
    left: 1px;
    top: 5px;
    width: 12px;
    z-index: 2;
  }
}

.location__item__label,
.location__item__address,
.location__item__complement {
  line-height: normal;
}

.location__item__label,
.location__item__complement {
  color: $gray-6;
  font-size: 12px;
}

.location__item__address,
.location__item__complement {
  margin-bottom: 0;
}

.location__item__label {

  .v-btn {
    font-size: 9px;
    height: 14px;
    margin: 6px 8px;
    min-width: auto;
    padding: 0 10px;
  }
}

.location__item__address {
  margin-bottom: 3px;
}
</style>
